import React, { useEffect, useState, useMemo } from 'react';
import { useIntl } from 'react-intl';
import QuizSubmitButtons from '../../QuizSubmitButtons';
import { useQuizContext } from '../../../../context/QuizContext';
import { Input } from '@osmosis/react-ui/components/Input';
import { P } from '@osmosis/react-ui/components/Text';
import { Box, Flex } from '@osmosis/react-ui/components/Box';
import { QuizContainer } from '../../QuizContainer';
import { CorrectBanner } from '../utils';
import {
  FillInTheBlankSubmittedAnswerType,
  FillInTheBlanksData,
} from '../../../../types/quiz';

/**
 * FillInTheBlank.
 */
const FillInTheBlank = () => {
  const {
    currentItem,
    currentResponseItem,
    submitAnswer,
    isAnswered,
    currentIndex,
  } = useQuizContext();

  const { answer, image, question, units } =
    currentItem?.data as FillInTheBlanksData;

  const [value, setValue] = useState('');
  const currentValue =
    (currentResponseItem?.response
      ?.answer as FillInTheBlankSubmittedAnswerType) || value;
  const intl = useIntl();

  const isCorrect = useMemo(() => {
    if (value) {
      const el = document.createElement('div');
      el.innerHTML = answer;
      const extractedAnswer = el.textContent;

      return (
        JSON.stringify(extractedAnswer?.toLocaleLowerCase().trim()) ===
        JSON.stringify(value.toLowerCase().trim())
      );
    }
    return false;
  }, [value, answer]);

  useEffect(() => {
    setValue('');
  }, [currentIndex]);

  const correctAnswer = intl.formatMessage(
    {
      id: 'quiz.fill-in-the-blank.correct',
      defaultMessage: 'The correct answer is {answer} {units}',
    },
    { answer, units },
  );

  return (
    <QuizContainer>
      <Flex
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        mb={4}
      >
        <Flex flexDirection="column" width="100%">
          <P dangerouslySetInnerHTML={{ __html: question }} mb={4} />
          <Flex alignItems="end">
            <Input
              disabled={isAnswered}
              data-testid="fill-in-the-blank-input"
              value={currentValue}
              onKeyDown={(event) => {
                event.stopPropagation();
              }}
              onChange={(event) => {
                setValue(event.target.value);
              }}
              sx={{ maxWidth: '300px', padding: '5px 10px' }}
            />
            {units && <P ml={3}>{units}</P>}
          </Flex>
        </Flex>
        {image && <Box as="img" sx={{ width: '300px' }} src={image} />}
        {isAnswered && (
          <CorrectBanner
            explanation={correctAnswer}
            isCorrectAnswer={isCorrect}
            sx={{ width: '100%' }}
          />
        )}
      </Flex>
      {!isAnswered && !!value && (
        <QuizSubmitButtons
          data-testid="submit-buttons"
          submit={(c) => submitAnswer(c, isCorrect, value)}
        />
      )}
    </QuizContainer>
  );
};

export default FillInTheBlank;
